import ApiService from '../apiservice'

// Cards e gráficos da tela de Publicações: recebem o mesmo filtro da consulta (PublicacoesService.consultarPublicacoes)
const parametros = (filtro) =>
	`dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&pessoa=${encodeURIComponent(filtro.pessoa)}&numeroProcesso=${filtro.numeroProcesso}&advogado=${encodeURIComponent(filtro.advogado)}&lidas=${filtro.publicacoesLidas}&statusProcessuais=${filtro.statusProcessuais}&gruposTrabalho=${filtro.gruposTrabalho}&tribunais=${encodeURIComponent(filtro.tribunais)}&areasAtuacao=${filtro.areasAtuacao}&usuarioId=${filtro.usuario}&empresaId=${filtro.empresa}`;

export default class ResumoIntimacoesService extends ApiService {
	constructor() {
		super('/resumo-intimacoes')
	}

	resumo(filtro) {
		return this.get(`/resumo?${parametros(filtro)}`);
	}

	graficoGrupoTrabalho(filtro) {
		return this.get(`/grupo-trabalho?${parametros(filtro)}`);
	}

	graficoStatusProcessual(filtro) {
		return this.get(`/grupo-status-processual?${parametros(filtro)}`);
	}

	graficoAreaAtuacao(filtro) {
		return this.get(`/area-atuacao?${parametros(filtro)}`);
	}

	graficoTribunal(filtro) {
		return this.get(`/tribunal?${parametros(filtro)}`);
	}
}
